import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DealNote",
  "use": "DealNote-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"DealNote\">\n  <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <path d=\"M0,15.833912 L0,20 L4.16608804,20 L16.4532704,7.71281766 L12.2871824,3.54672962 L0,15.833912 Z M19.6750451,4.49104291 C20.1083183,4.05776975 20.1083183,3.35786696 19.6750451,2.92459381 L17.0754063,0.324954862 C16.642133,-0.108318287 15.9422303,-0.108318287 15.5089571,0.324954862 L13.4759061,2.35800584 L17.6419941,6.52409388 L19.6750451,4.49104291 Z\" fill=\"currentColor\" fill-rule=\"nonzero\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol